import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { showErrorToast, showSuccessToast } from '../../../utils/toastUtils';
import { reOrderTopicsAndTalkingPoints, type TopicDto } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export function useReorderTopic(): UseMutationResult<TopicDto, AxiosError, TopicDto> {
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (event) => reOrderTopicsAndTalkingPoints({ body: event }).then((result) => result.data!),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.topics() });
            queryClient.invalidateQueries({ queryKey: queryKeys.fullTopics() });
            showSuccessToast(t('successActionGeneric'));
        },
        onError: (error) => showErrorToast({ error, userMessage: t('failureActionGeneric') }),
    });
}
